export default __webpack_public_path__ + "static/media/Jason.237258ab.mp3";